import React from "react";
import {useTranslation} from "../../i18n/LanguageProvider";

export default function TravelRequirementsNotice({active, empty}: {active: boolean; empty: boolean}) {
  const {t} = useTranslation();
  if (!active || !empty) return null;
  return <div role="status" className="rounded-xl bg-purple-50 px-4 py-3 text-left text-xs leading-relaxed text-gray-700">
    <p>{t("visa.empty")}</p>
  </div>;
}
